import { fetchAll } from '@/api/depart';
import { toTree } from '@/utils/tree';
import types from '../types';

const state = {
  allDeparts: [],
  departs: [],
  departTree: []
}

const mutations = {
  [types.SET_ALLDEPARTS](state, allDeparts) {
    state.allDeparts = allDeparts;
  },
  [types.SET_DEPARTS](state, departs) {
    state.departs = departs;
    state.departTree = toTree(departs);
  }
};

const actions = {
  fetchDeparts({ commit }) {
    this.tableLoading = true;
    return fetchAll()
      .then(res => {
        const allDeparts = (res.data.data || []).filter(e => String(e.id) !== '0').map(depart => {
          return { ...depart, disabled: depart.status !== 'enable' };
        })
        const departs = allDeparts.filter(e => e.status !== 'delete');
        commit(types.SET_ALLDEPARTS, allDeparts || []);
        commit(types.SET_DEPARTS, departs || []);
        this.tableLoading = false;
      })
      .catch(error => {
        this.tableLoading = false;
        Promise.reject(error);
      });
  }
};

export default {
  state,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/modules/depart.js